import { createTracker } from 'usage-tracker';
const NAMESPACE = 'Customer Data Properties';
const EVENT_NAMES = {
  INTERACTION: 'Interaction',
  PAGEVIEW: 'Pageview'
};
export const usageTracker = createTracker({
  standalone: true
});
export const standaloneUsageTracker = createTracker({
  standalone: true,
  properties: {
    screen: 'customer-data-properties'
  }
});
export const trackConditionalPropertiesPanelSubmit = () => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    subscreen: `conditional-properties-panel`,
    action: 'submit'
  });
};
export const trackAutosaveSuccess = ({
  identifiers,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'autosave success',
    type: 'PROPERTY',
    objectTypeId,
    propertyNames: identifiers
  });
};
export const trackAutosaveUndo = ({
  identifiers,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'autosave undo',
    type: 'PROPERTY',
    propertyNames: identifiers,
    objectTypeId
  });
};
export const trackShowHighlySensitiveValueClick = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    propertyName,
    objectTypeId,
    action: 'show highly sensitive value'
  });
};
export const trackRejectedReviveDealSubmit = () => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'revive rejected deal'
  });
};
export const logPageView = payload => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.PAGEVIEW, Object.assign({}, payload, {
    screen: `customer-data-properties`
  }));
};
export const trackExpandableTextCollapse = ({
  component,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    subscreen: component,
    action: 'expandable text collapse',
    propertyName,
    objectTypeId
  });
};
export const trackExpandableTextExpand = ({
  component,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    subscreen: component,
    action: 'expandable text expand',
    propertyName,
    objectTypeId
  });
};
export const trackDetailsLinkButtonClick = ({
  propertyName,
  objectTypeId,
  type
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'details link button click',
    type,
    propertyName,
    objectTypeId
  });
};
export const trackDocumentationLinkButtonClick = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: `customer-data-properties`,
    action: 'property documentation link button click',
    propertyName,
    objectTypeId
  });
};
export const trackFormattedPropertyPhoneClick = ({
  objectTypeId
}) => {
  usageTracker.track(NAMESPACE, EVENT_NAMES.INTERACTION, {
    screen: 'customer-data-properties',
    action: 'initiate call',
    objectTypeId
  });
};